import React, { Component } from 'react';
import Images from '../ImagesComponent/Images';
import '../css/FooterSimple.css';

class FooterSimple extends Component {
    render() {
        return (
            <div id="footer" className="container-fluid footer-simple-container">
                <div className="container">
                    <div className="" style={{ marginTop: "10px" }}>
                        <div className="col-sm-6 col-xs-12 box-container" style={{paddingLeft:'0px'}}>
                            <div style={{boxShadow: 'rgba(0, 0, 0, 0.1) 1px 1px 15px', borderRadius: '12px', padding:'24px', position:'relative'}}>
                                <span style={{fontFamily:'Rubik', fontWeight:'700', fontSize:'16px', color:'#7D61D6'}}>Kerjasama sebagai Mitra di Fammi</span>
                                <div style={{clear:'both'}}>
                                </div>
                                <div style={{marginTop:'4px', fontFamily:'Lato', fontSize:'14px', maxWidth:'336px', float:'left'}}>
                                    Banyak keluarga di Indonesia menunggu Anda. Mari bersama memberikan kontribusi terbaik. Daftar menjadi Mitra FAMMI sekarang !
                                </div>
                                <div className="buttoncontainer">
                                    <a href="/#" className="fammibutton2">Selengkapnya</a>
                                </div>
                                <div style={{clear:'both'}}>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-12 box-container" style={{paddingRight:'0px'}}>
                            <div style={{boxShadow: 'rgba(0, 0, 0, 0.1) 1px 1px 15px', borderRadius: '12px', padding:'24px', position:'relative'}}>
                                <span style={{fontFamily:'Rubik', fontWeight:'700', fontSize:'16px', color:'#7D61D6'}}>Jadi Orangtua Pembelajar di Fammi</span>
                                <div style={{clear:'both'}}>
                                </div>
                                <div style={{marginTop:'4px', fontFamily:'Lato', fontSize:'14px', maxWidth:'336px',  float:'left'}}>
                                    Akses puluhan kelas untuk meningkatkan kualitas sebagai orangtua masa kini. Gabung segera menjadi orangtua pembelajar.
                                </div>
                                <div className="buttoncontainer">
                                    <a href="/#" className="fammibutton2" style={{width:'134px', textAlign:'center'}}>Daftar</a>
                                </div>
                                <div style={{clear:'both'}}>
                                </div>
                            </div>
                        </div>
                        <div className="clearing"></div>
                    </div>

                    <div className="row bottomlogo">
                        <div className="col-md-3 col-sm-12 col-xs-12">
                            <img alt="" className="footerimagelogo" src={require("../images/new-logo-fammi.svg")} width="108px" height="32px" />
                        </div>
                        <div className="col-md-9 col-sm-12 col-xs-12 footercopyrightcontainer">
                            <a href="/kebijakan">Kebijakan Data</a>
                            <a href="/ketentuan">Syarat & Ketentuan</a>
                            <a href="/tentang">Tentang Kami</a>
                            <a className="footercopyright" href="/#"> Copyright © 2022 Fammi Indonesia</a>
                        </div>
                    </div>

                    <div id="whatsapp-container" className="colorbg3" style={{position:'fixed',bottom:'20px',zIndex: '999', right:'20px', padding:'10px 20px', borderRadius: '24px', border:'none', color:'#FFF', fontFamily: 'Rubik', fontSize: '14px', fontWeight: '500'}}>
                        <a href="https://wa.me/+628119291200" className="colorbg3" style={{margin:'0px',color:'#FFF'}}>
                        <Images src="/static/media/wa-white.2be8c8a1.svg" style={{marginRight:'10px', display: 'inline' }} />Bantuan
                      </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default FooterSimple